export default {
  methods: {
    filterHeaders() {
      return this.possibleHeaders.filter(header => {
        if (header.value == "actions") { return true }
        return !!this.defaultHeaders.filter(field => {
          return header.value == field
        }).length
      })
    }
  },
  computed: {
    headers() {
      var tempArray = this.filterHeaders()

      var actions = {
        text: "Actions",
        align: "center",
        value: "",
        sortable: false,
        colData: "",
        type: "action"
      };
      tempArray.push(actions)

      return tempArray
    },
    possibleHeaders() {
      var tempHeaders = this.allPossibleHeaders;
      if (!this.userShowCost && this.$route.name != 'userAuthClass') {
        tempHeaders = tempHeaders.filter(header => {
          return !header.value.includes('cost')
        })
      }
      if (!this.userShowSell && this.$route.name != 'userAuthClass') {
        tempHeaders = tempHeaders.filter(header => {
          return !header.value.includes('sell')
        })
      }
      return tempHeaders;
    }
  },
}